import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=4709dbe1&scoped=true"
import script from "./IconButton.vue?vue&type=script&lang=js"
export * from "./IconButton.vue?vue&type=script&lang=js"
import style0 from "./IconButton.vue?vue&type=style&index=0&id=4709dbe1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4709dbe1",
  null
  
)

export default component.exports